<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">
					Integrated Supply Chain for Contract Manufacturing Clients
				</div>
				<div class="txt" style="text-align: center;">
					World-Class IVD Contract Manufacturing on Your Schedule.
				</div>
				<div class="bg_box">
					<img src="../../assets/img_h5/20230704-094648.webp" />
				</div>
				<div class="txt">
					CorDx is a global leader in IVD product contract manufacturing. Unlike other contract manufacturers, CorDx owns its own manufacturing supply chain from bottom to top to ensure the world has access to accurate, affordable, easy-to-use diagnostics products with competitive pricing. Our fully integrated supply chain removes barriers to accessibility and provides cost savings and flexibility. It’s one way we ensure our clients receive their diagnostics products when promised.
				</div>
				<div class="txt">
					CorDx provides full supply-chain support for our diagnostics development and contract manufacturing customers. This includes access to raw materials, rapid testing medical device products, and plastic consumable supplies used in point-of-care lateral flow tests.
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">Company Highlights</div>
				<div class="block_2_el">
					<div class="tit">1,000+</div>
					<div class="txt">Global Business Partners</div>
				</div>
				<div class="block_2_el">
					<div class="tit">3 Million+</div>
					<div class="txt">Sq. Ft. Footprint</div>
				</div>
				<div class="block_2_el">
					<div class="tit">1 Billion+</div>
					<div class="txt">Users of CorDx-manufactured Products Worldwide</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="title">Supply Chain Benefits</div>
				<div v-for="(value, index) in dataList" :key="index" class="block_3_el">
					<div class="img_box">
						<img :src="value.image" />
					</div>
					<div class="tit">{{ value.title }}</div>
					<div class="txt">{{ value.text }}</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="bg_box">
					<img src="../../assets/img_h5/图像 39@2x.webp" />
				</div>
				<div class="title">Our Global Network</div>
				<div class="text">
					CorDx’s global footprint enables an integrated supply chain for end-to-end IVD development and manufacturing. We maintain a global network of distribution relationships with some of the world’s leading suppliers to ensure you get your products when promised.
				</div>
				<div class="block_4_el">
					<div class="tit">UNITED STATES</div>
					<div class="txt">
						CorDx has a bicoastal presence in the US for product development, testing, manufacturing, and assembly services.
					</div>
					<div class="txt" style="font-weight: bold;">
						●  San Diego, Calif:
					</div>
					<div class="txt" style="text-indent: 20px;">
						Late-phase production for IVD developers, including the cutting of lateral flow assay cards/sheets, test cassette assembly, test cassette pouching, and kitting.
					</div>
					<div class="txt" style="font-weight: bold;">
						●  Atlanta, Ga.:
					</div>
					<div class="txt" style="text-indent: 20px;">
						Injection molding for test cassettes, lateral flow sheet development, and more.
					</div>
				</div>
				<div class="block_4_el">
					<div class="tit">CHINA</div>
					<div class="txt">
						CorDx’s full-scale manufacturing facility and R&D team in China supports the production of millions of rapid testing products with the flexibility to scale up and down depending on your business requirements and market demand.
					</div>
				</div>
				<div class="block_4_el">
					<div class="tit">SINGAPORE</div>
					<div class="txt">
						CorDx’s Singapore facility functions as its headquarters in the Asia-Pacific (APAC) region. This location expands the global distribution of CorDx’s diagnostic tests in the APAC region. The business development center is now operational, while the R&D facility is expected to be completed in one to two years.
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_5_el" style="background-color: #FEFCFC;">
					<div class="tit">Ownership​</div>
					<div class="txt">
						CorDx’s resources and tooling capabilities include ownership of its own raw material pipeline and close relationships with producers of materials not owned by CorDx.
					</div>
					<div class="img_box">
						<img src="../../assets/img_h5/蒙版组 1@2x.webp" />
					</div>
				</div>
				<div class="block_5_el" style="background-color: #FEFBF3;">
					<div class="tit">Supported IVD Technologies & Techniques​</div>
					<div class="list" style="padding-bottom: 20px;">
						<ul>
							<li>●  Lateral Flow Immunoassays</li>
							<li>●  ELISA Immunoassays</li>
							<li>●  Visible, fluorescent, and chemiluminescent detection systems</li>
							<li>●  Real-time PCR</li>
							<li>●  Dry clinical chemistry</li>
							<li>●  Microfluidics</li>
							<li>●  Recombinant proteins and antibodies</li>
						</ul>
					</div>
					<div class="img_box">
						<img src="../../assets/img_h5/蒙版组 1@12x.webp" />
					</div>
				</div>
				<div class="block_5_el" style="background-color: #FBFEFC;">
					<div class="img_box">
						<img src="../../assets/img_h5/img@2x.webp" />
					</div>
					<div class="tit">Contract Manufacturing</div>
					<div class="txt">
						We provide contract manufacturing solutions for startups to large enterprises alike. CorDx performs contract manufacturing for products we developed as well as from technology transfers. Trust CorDx for efficient manufacturing, quality products, and proficiency in regulatory affairs.
					</div>
					<div class="btn_box_ty btn_box" @click="goContractManufacturing">
						Learn More<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
				<div class="block_5_el" style="background-color: #F9FAFE;">
					<div class="img_box">
						<img src="../../assets/img_h5/image@2x (2).webp" />
					</div>
					<div class="tit">IVD Applications​</div>
					<!-- <div class="txt">
						CorDx provides raw IVD materials and consumables for:
					</div> -->
					<div class="list" style="padding-bottom: 20px;">
						<ul>
							<li>●  Respiratory Diseases</li>
							<li>●  Infectious Diseases</li>
							<li>●  Sexually Transmitted Diseases</li>
							<li>●  Fertility Monitoring</li>
							<li>●  Drugs of Abuse</li>
							<li>●  Cardiac Markers</li>
							<li>●  Tumor Markers</li>
							<li>●  Health Tests</li>
							<li>●  Blood Glucose</li>
							<li>●  And more</li>
						</ul>
					</div>
				</div>
			</div>
			<!--块6-->
			<div class="block_6"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img class="bg" src="../../assets/img_h5/组 696@2x.webp" />
				<div class="block_6_main">
					<div class="tit">Partner With Us</div>
					<div class="txt">
						CorDx partners with organizations around the world to develop, manufacture, and distribute diagnostics that empower users to monitor and improve their health.
					</div>
					<div class="txt">
						Through these partnerships, we can best serve those who need it with collaboration, insight, and effectiveness. Do you have a breakthrough you believe will benefit from collaboration with CorDx?
					</div>
					<div class="btn_box_ty btn_box" @click="goContact">
						Contact Us<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块6-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			dataList: [
				{ id: 1, image: require('@/assets/img_h5/路径 431@2x.png'), title: 'Quality Control', text: "Each stage of CorDx's supply chain operation is optimized to maintain the quality standards we're known for.", },
				{ id: 2, image: require('@/assets/img_h5/组 693@2x.png'), title: 'Accessibility', text: "Our vertically integrated supply chain provides diagnostics customers with the peace of mind that comes with assured product delivery, anywhere in the world.", },
				{ id: 3, image: require('@/assets/img_h5/组 707@2x.png'), title: 'Cost Savings', text: "CorDx's integrated supply chain leads to cost savings for our customers and enables us to focus on your requirements instead of material procurement.", },
				{ id: 4, image: require('@/assets/img_h5/组 708@2x.png'), title: 'Flexibility', text: "Our supply chain is agile and scalable, enabling us to flexibly respond to your changing business requirements.", },
			],
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goContractManufacturing() {
			this.$router.push({ path: '/contract-manufacturing', });
		},
		goContact() {
			this.$router.push({ path: '/contact', });
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块6*/
	.block_6{
		position: relative;
		.block_6_main{
			position: absolute;
			top: 84px;
			width: 100%;
			padding: 0 20px;
			.btn_box{
				background-color: #F5F8FA;
				border: 1px solid #CBD6E2;
			}
			.txt{
				padding-bottom: 30px;
				color: #ffffff;
				font-size: 18px;
			}
			.tit{
				padding-bottom: 14px;
				color: #ffffff;
				font-size: 45px;
			}
		}
		.bg{
			width: 100%;
		}
	}
	/*块5*/
	.block_5{
		padding: 0 20px 42px 20px;
		.block_5_el{
			margin-bottom: 42px;
			padding: 42px 16px 0 16px;
			.img_box{
				padding-bottom: 42px;
				img{ width: 100%; }
			}
			.btn_box{
				margin: 34px 0;
			}
			.list{
				padding-top: 20px;
				li{
					padding: 5px 0;
					font-size: 18px;
				}
			}
			.txt{
				padding-top: 20px;
				padding-bottom: 20px;
				font-size: 18px;
				color: #000000;
			}
			.tit{
				font-size: 36px;
				color: #000000;
			}
		}
	}
	/*块4*/
	.block_4{
		padding: 0 0 42px 0;
		.block_4_el{
			padding: 0 20px 42px 20px;
			.txt{
				padding: 5px 0;
				font-size: 18px;
			}
			.tit{
				color: #0B318F;
				font-size: 24px;
			}
		}
		.text{
			padding: 22px 20px 50px 20px;
			font-size: 18px;
		}
		.title{
			padding: 42px 20px 0 20px;
			font-size: 36px;
		}
		.bg_box{
			img{ width: 100%; }
		}
	}
	/*块3*/
	.block_3{
		padding: 84px 20px 42px 20px;
		.block_3_el{
			padding-bottom: 42px;
			.txt{
				font-size: 20px;
			}
			.tit{
				padding: 20px 0 22px 0;
				font-size: 24px;
			}
			.img_box{
				width: 105px;
				height: 105px;
				img{ width: 100%;height: 100%; }
			}
		}
		.title{
			padding-bottom: 21px;
			font-size: 36px;
		}
	}
	/*块2*/
	.block_2{
		padding: 64px 20px;
		background-color: #0066D4;
		.block_2_el{
			margin-top: 20px;
			padding: 42px 0;
			background-color: #ffffff;
			text-align: center;
			.txt{
				font-size: 18px;
			}
			.tit{
				font-size: 42px;
				color: #0B318F;
			}
		}
		.title{
			font-size: 36px;
			color: #ffffff;
		}
	}
	/*块1*/
	.block_1{
		padding: 22px 0 64px 0;
		color: #3D3D3D;
		.bg_box{
			padding-bottom: 42px;
			img{ width: 100%; }
		}
		.txt{
			padding: 0 20px 30px 20px;
			font-size: 20px;
		}
		.tit{
			text-align: center;
			padding: 0 20px;
			font-size: 42px;
		}
	}
}
</style>
